
export class RutaCliente {

    public cod_ruta: number;
    public des_ruta: string;
    //public cod_cliente: any;
    //public minuto_alerta: any;
    //public istrack: any;
    //public fecha_hora: any;
    //public isrte: any;
    //public temporal: any;

    constructor(data: any) {
        this.cod_ruta = data.cod_ruta;
        this.des_ruta = data.des_ruta;        
    }

}